import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  confirmed: "bg-[hsl(165_37%_17%)] text-white",
  pending: "bg-[hsl(42_22%_88%)] text-[hsl(90_4%_10%)]",
  cancelled: "bg-red-100 text-red-700",
  completed: "bg-blue-100 text-blue-700",
};

export default function MyBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/bookings/my")
      .then((r) => setBookings(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-5xl px-6 md:px-10 py-12" data-testid="my-bookings-page">
      <p className="text-xs uppercase tracking-[0.25em] text-[hsl(10_51%_55%)]">Your journeys</p>
      <h1 className="font-serif-display text-3xl sm:text-4xl mt-2 mb-10">My bookings</h1>

      {loading ? (
        <div className="text-center py-16 text-[hsl(100_3%_30%)]">Loading…</div>
      ) : bookings.length === 0 ? (
        <div className="text-center py-16">
          <p className="font-serif-display text-2xl mb-3">Nothing planned yet.</p>
          <p className="text-[hsl(100_3%_30%)] mb-6">Browse our collection and book your next escape.</p>
          <Link to="/search" className="inline-flex items-center btn-terracotta rounded-full px-6 py-3 text-sm">Explore stays</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {bookings.map((b) => (
            <div key={b.id} className="flex flex-col sm:flex-row gap-5 border border-[hsl(165_37%_17%/0.1)] rounded-md p-5 bg-white" data-testid={`booking-${b.id}`}>
              <img src={b.property?.images?.[0]} alt="" className="h-32 w-full sm:w-40 rounded object-cover" />
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-start justify-between gap-2">
                  <div className="min-w-0">
                    <p className="text-xs text-[hsl(100_3%_30%)]">{b.property?.location}</p>
                    <h3 className="font-serif-display text-xl mt-1 truncate">{b.property?.title}</h3>
                  </div>
                  <Badge className={STATUS_STYLES[b.status] || "bg-gray-100 text-gray-700"} data-testid={`booking-status-${b.id}`}>{b.status}</Badge>
                </div>
                <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
                  <div>
                    <p className="text-[10px] uppercase tracking-widest text-[hsl(100_3%_30%)]">Check in</p>
                    <p>{b.check_in}</p>
                  </div>
                  <div>
                    <p className="text-[10px] uppercase tracking-widest text-[hsl(100_3%_30%)]">Check out</p>
                    <p>{b.check_out}</p>
                  </div>
                  <div>
                    <p className="text-[10px] uppercase tracking-widest text-[hsl(100_3%_30%)]">Guests</p>
                    <p>{b.guests}</p>
                  </div>
                  <div>
                    <p className="text-[10px] uppercase tracking-widest text-[hsl(100_3%_30%)]">Total</p>
                    <p>₹{b.total_amount.toLocaleString("en-IN")}</p>
                  </div>
                </div>
                <div className="mt-3 text-xs text-[hsl(100_3%_30%)]">
                  Payment: <span className="font-medium">{b.payment_status}</span> · Booked {new Date(b.created_at).toLocaleDateString()}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
